import React from 'react';
import {Link as RouterLink} from "react-router-dom";
import { TERMS_V11_EFFECTIVE_AT } from "./clauseVersionDates";

const UseAgreement = () => {
    const isTermsV11Effective = new Date() >= TERMS_V11_EFFECTIVE_AT;

    return (
          <>
            <div className='p-3'>
                <h2 className='fs-4'>이용약관</h2>
                <div className="d-flex justify-content-end flex-wrap gap-2 mb-3">
                    <RouterLink
                        to="/clause/use"
                        className="text-decoration-none"
                        style={{
                            border: '1px solid #cbd5e1',
                            background: '#fff',
                            color: '#334155',
                            borderRadius: '999px',
                            padding: '9px 16px',
                            fontSize: '13px',
                            fontWeight: 600
                        }}
                    >
                        {isTermsV11Effective ? "현재 버전" : "예정 버전"}
                    </RouterLink>
                    {!isTermsV11Effective && (
                        <span
                            style={{
                                border: '1px solid #2563eb',
                                background: '#2563eb',
                                color: '#fff',
                                borderRadius: '999px',
                                padding: '9px 16px',
                                fontSize: '13px',
                                fontWeight: 600
                            }}
                        >
                            현재 버전
                        </span>
                    )}
                </div>
                <div className='agree-wrap '>
                    <div className="agree-box full-height" >
                        <div className="terms-wrap">
                            <h5>제1장 총칙</h5>
                            <div className="sec">
                                <h3>제 1 조 (목적)</h3>
                                <p>본 이용약관(이하 "약관")은 비즈톡 주식회사(이하 "회사")가 운영하는 비즈팅 서비스(이하 '비즈팅' 또는 '서비스'라 합니다)에서 사용하는 지불 및 결제 수단(이하 '비즈팅 포인트'라 합니다)을 사용함에 있어 회사와 이용고객(이하 '회원'이라 합니다)간에 비즈팅 포인트에 대한 충전 및 사용에 관해서 상호간 준수해야 할 사항, 이용조건 및 절차와 기타 필요한 제반 사항을 규정함을 목적으로 합니다.</p>
                            </div>
                            <div className="sec">
                                <h3>제 2 조 (용어의 정의)</h3>
                                <p>이 "약관"에서 사용하는 용어의 정의는 다음과 같습니다.</p>
                                <ol>
                                    <li>(1) 서비스: 비즈팅 서비스는 SKT 회선 이용 고객을 대상으로 타겟팅 하여 사업자인 회원의 마케팅 캠페인을 문자메시지 형태로 제공하는 회사의 서비스를 말합니다. </li>
                                    <li>(2) 회사: 비즈톡 주식회사가 운영하는 온라인서비스 혹은 사업자의 의미로도 사용합니다. </li>
                                    <li>(3) 이용고객: 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
                                    <li>(4) 회원: 회사와 서비스 이용계약을 체결하고 회원 아이디를 부여받은 자를 말합니다.</li>
                                    <li>(5) 아이디(ID): 회원 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 문자와 숫자의 조합입니다.</li>
                                    <li>(6) 비밀번호(PW): 회원의 비밀보호를 위하여 회원자신이 설정한 문자와 숫자의 조합을 말합니다.</li>
                                    <li>(7) 운영자: 서비스의 전반적인 관리와 원활한 운영을 위하여 회사에서 선정한 사람을 말합니다.</li>
                                    <li>(8) 해지: 회사 또는 회원이 이용 계약을 해약하는 것을 말합니다.</li>
                                    <li>(9) 비즈팅 포인트: 회사가 인정하는 방법을 통하여 생성되며, 회사에서 제공하는 유료 서비스를 이용하실 수 있는 사이버 캐시를 말합니다.</li>
                                    <li>(10) 충전: '비즈팅 포인트'를 회사에서 제공하는 결제 방식을 통해 일정 금액 단위로 '비즈팅 포인트'를 구입하는 것을 말합니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 3 조 (약관의 적용과 개정)</h3>
                                <ol>
                                    <li>(1) 회사는 본 "약관"을 "홈페이지”에 게시하는 방법으로 공지하며 서비스 이용 신청(계약) 시 이용고객으로부터 "약관"에 대한 동의를 받습니다.</li>
                                    <li>(2) 회사는 "약관의 규제에 관한 법률", "정보통신망법"등 관련법을 위배하지 않는 범위에서 본 "약관"을 개정할 수 있습니다.</li>
                                    <li>(3) 회사가 본 "약관"을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 그 적용일자 30일 이전부터 적용일자 전일까지 공지합니다.</li>
                                    <li>(4) 회사가 전항에 따라 개정 약관을 공지 또는 통지하면서 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 회원에게 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정 약관에 동의한 것으로 봅니다.</li>
                                    <li>(5) 회원이 개정 약관의 적용에 동의하지 않는 경우 회사는 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 계약을 해지할 수 있습니다. 다만, 기존 "약관"을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다.</li>
                                    <li>(6) 새로운 서비스가 개설될 경우 별도의 명시된 설명이 없는 한 본 "약관"에 따라 제공합니다.</li>
                                    <li>(7) 회사는 서비스에 부수하여 타 서비스와 연계한 통합서비스 또는 별도의 서비스 등을 제공할 수 있으며 이용조건 등은 별도로 공지하는 바에 따릅니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 4 조 (약관 외 준칙)</h3>
                                <p>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
                                <ol>
                                    <li>(1) 본 "약관"은 회사가 제공하는 서비스에 관하여 별도의 정책 및 운영규칙과 함께 적용됩니다.</li>
                                    <li>(2) 본 "약관"의 해석은 대한민국 법에 의하여 해석되고 적용되며, "약관"에서 정하지 아니한 사항은 전기통신기본법, 전기통신사업법 및 기타 관계법령 또는 상관례에 따릅니다. </li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 5 조 (개인정보취급방침의 적용)</h3>
                                <ol>
                                    <li>(1) 회사는 관계 법령이 정하는 바에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해 노력합니다. 이용자 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 '개인정보 처리방침'에 따릅니다.</li>
                                    <li>(2) 회사는 회사가 제공하는 서비스의 회원을 대상으로 서비스의 양적, 질적 향상을 위하여 회원의 개인 식별이 가능한 개인정보를 회원의 동의를 받아 수집하여 서비스에 이용할 수 있습니다.</li>
                                    <li>(3) 회사가 수집하는 개인정보는 서비스의 제공에 필요한 최소한으로 하되, 필요한 경우 자세한 정보를 요구할 수 있습니다.</li>
                                    <li>(4) 회사는 개인정보의 수집 시 관련 법규에 따라 서비스 이용 신청서 또는 계약서 및 "약관"에 그 수집 범위 및 목적을 사전 고지하며 회사의 "개인정보처리방침"에 공개합니다.</li>
                                    <li>(5) 회사는 서비스 제공과 관련하여 취득한 회원의 개인정보를 본인의 동의 없이 제3자에게 제공 또는 배포할 수 없으며 상업적 목적으로 사용할 수 없습니다. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우에는 그러하지 아니합니다.</li>
                                </ol>
                            </div>
                            <h5>제2장 서비스 이용</h5>
                            <div className="sec">
                                <h3>제 6 조 (이용계약의 성립)</h3>
                                <ol>
                                    <li>(1) 서비스 가입 신청 시 본 약관을 읽고 "동의합니다"에 체크 후 "확인" 버튼을 누르면 이 약관에 동의하는 것으로 간주되며 이용계약은 서비스 이용자가 이용신청 동의 후 회사가 승낙함으로써 성립합니다.
                                    </li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 7 조 (이용 신청)</h3>
                                <ol>
                                    <li>(1) 이용 신청은 온라인으로 회사가 요청하는 소정의 가입신청 양식에서 요구하는 사항을 기록하여 신청합니다.</li>
                                    <li>(2) 가입신청양식에 기재하는 모든 회원 정보는 실제 데이터인 것으로 간주하며 실명이나 실제 정보를 입력하지 않은 사용자는 법적인 보호를 받을 수 없으며, 서비스 사용의 제한을 받을 수 있습니다.</li>
                                    <li>(3) 타인의 정보를 도용하는 등 부정한 목적과 방법으로 이용신청을 한 회원의 ID는 사전 통지 없이 삭제될 수 있습니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 8 조 (이용신청의 승낙)</h3>
                                <ol>
                                    <li>(1) 회사는 회원이 제2장 7조에서 정한 모든 사항을 정확히 기재하여 이용신청을 하였을 때 특별한 사정이 없는 한 접수 순서대로 이용신청을 승낙합니다.</li>
                                    <li>(2) 회사는 다음 각 호에 해당하는 이용신청에 대하여는 승낙을 유보할 수 있고, 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.
                                        <ol>
                                            <li>가. 서비스 관련 설비에 여유가 없는 경우</li>
                                            <li>나. “회사”의 운영상, 사업상 위해 요소 또는 위해 우려가 있는 경우</li>
                                            <li>다. 기술상 지장이 있는 경우</li>
                                            <li>라. 기타 회사의 사정으로 이용 승낙이 곤란한 경우</li>
                                        </ol>
                                    </li>
                                    <li>(3) 회사는 다음 각 호에 해당하는 이용신청에 대하여는 승낙을 제한할 수 있습니다.
                                        <ol>
                                            <li>가. 실명이 아닌 정보 또는 다른 사람의 정보를 사용하는 경우</li>
                                            <li>나. 이용 신청 시 필요내용을 허위로 기재하여 신청한 경우</li>
                                            <li>다. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우</li>
                                            <li>라. 기타 회사가 정한 이용신청요건이 미비된 경우</li>
                                            <li>마. 신용정보의 이용과 보호에 관한 법률에 의한 PC통신, 인터넷서비스의 채무불이행자로 등록되어 있는 경우</li>
                                            <li>바. 기타 회원으로 등록하는 것이 서비스의 기술상 또는 업무 수행상 현저히 지장이 있다고 판단하는 경우</li>
                                            <li>사. 회원으로 등록하는 것이 회사의 정책상 적합하지 않다고 판단되는 경우</li>
                                        </ol>
                                    </li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 9 조 (회원정보의 변경)</h3>
                                <p>회원은 개인정보관리를 통해 언제든지 개인정보를 열람하고 수정할 수 있습니다. 회원은 이용신청 시 기재한 사항이 변경되었을 경우에는 온라인으로 수정을 해야 하고 관리 소홀로 인하여 발생하는 서비스 이용상의 손해 또는 제3자에 의한 부정이용 등에 대한 책임은 이용자 본인에게 있으며, 회사는 그에 대한 책임을 일절 지지 않습니다.</p>
                            </div>
                            <div className="sec">
                                <h3>제 10 조 (“서비스”의 이용개시)</h3>
                                <ol>
                                    <li>(1) “회사”는 회원의 이용 신청을 승낙한 때부터 “서비스”를 개시합니다. 단, 일부 “서비스”의 경우에는 지정된 일자부터 “서비스”를 개시합니다.</li>
                                    <li>(2) “회사”의 업무상 또는 기술상의 장애로 인하여 “서비스”를 개시하지 못하는 경우에는 사이트에 공시하거나 이를 통지합니다. 단, 불가피한 사정에 의한 경우에는 사후 공지할 수 있습니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 11 조 (“서비스”의 이용시간)</h3>
                                <ol>
                                    <li>(1) “서비스”의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 단, “회사”의 업무상이나 기술상의 이유로 “서비스”가 일시 중지될 수 있고, 또한 운영 상의 목적으로 “회사”가 정한 기간에는 “서비스”가 일시 중지될 수 있습니다. 이러한 경우 “회사”는 사전에 이를 공지하며, 부득이한 경우 사후 공지할 수 있습니다.</li>
                                    <li>(2) “회사”는 “서비스”를 일정범위로 분할하려 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있으며 이 경우 그 내용을 공지합니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 12 조 (“서비스”의 변경 및 중지)</h3>
                                <ol>
                                    <li>(1) “회사”는 변경될 “서비스”의 내용 및 제공일자를 제20조에서 정한 방법으로 회원에게 통지하고 “서비스”를 변경하여 제공할 수 있습니다.</li>
                                    <li>(2) “회사”는 다음 각 호에 해당하는 경우 “서비스”의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
                                        <ol>
                                            <li>가. “서비스”용 설비의 보수 등 공사로 인한 부득이한 경우</li>
                                            <li>나. 회원이 “회사”의 영업 활동을 방해하는 경우</li>
                                            <li>다. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 “서비스” 제공에 지장이 있는 경우</li>
                                            <li>라. “서비스” 제공을 위하여 “회사”가 제3자와 체결한 계약의 종료 등 “회사”의 제반 사정으로 “서비스”를 유지할 수 없는 경우</li>
                                            <li>마. “서비스” 제공을 위한 ‘SKT’ 망 혹은 서버에 장애가 발생하여 정상적인 “서비스” 제공에 지장이 있는 경우.</li>
                                            <li>바. 기타 천재지변, 국가비상사태 등의 불가항력적 사유가 있는 경우</li>
                                        </ol>
                                    </li>
                                    <li>(3) 제2항에 의한 “서비스” 제한/중지의 경우 “회사”는 제20조에서 정한 방법으로 회원에게 통지합니다. 단, “회사”가 통제할 수 없는 사유로 인한 “서비스”의 중단(운영자에게 고의, 과실 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전통지가 불가능한 경우에는 그러지 아니합니다.</li>
                                    <li>(4) “회사”는 “서비스”의 변경, 제한이나 중지로 발생하는 문제에 대해서는 책임을 지지 않습니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 13 조 (문자 전송에 대한 회원의 의무와 책임)</h3>
                                <ol>
                                    <li>(1) 회원은 “서비스”를 통해 문자를 전송할 수 있습니다. 단, 회원의 자격에 따라 제한될 수 있습니다. </li>
                                    <li>(2) 회원은 본 조의 문자를 이용하여 수신자의 의사에 반하는 광고성 정보를 일시에 다량으로 또는 지속적으로 전송하거나 (불법)스팸을 전송해서는 안 됩니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 14 조 (정보의 제공 및 광고의 게재)</h3>
                                <p>“회사”는 “서비스”를 운영함에 있어 “회사”의 “서비스” 관련 각종 정보 및 광고를 “서비스” 화면에 게재하거나 E-mail 및 SMS, 기타 전자적 메채 활용 등의 방법으로 회원에게 제공할 수 있습니다.</p>
                            </div>
                            <div className="sec">
                                <h3>제 15 조 (게시물 또는 내용물의 삭제)</h3>
                                <ol>
                                    <li>(1) “회사”는 회원이 게시하거나 전달하는 “서비스”의 모든 내용물(회원간 전달 포함)이 각 호의 경우에 해당한다고 판단되는 경우 사전통지 없이 내용물을 삭제할 수 있으며, 이에 대해 “회사”는 책임을 지지 않습니다.</li>
                                    <ol>
                                        <li>가. “회사”, 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</li>
                                        <li>나. 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등의 유포에 해당하는 경우</li>
                                        <li>다. 범죄적 행위에 결부된다고 객관적으로 인정되는 내용인 경우</li>
                                        <li>라. “회사” 또는 제3자의 저작권 또는 기타 권리를 침해하는 내용인 경우</li>
                                        <li>마. 제2항 소정의 세부이용지침을 통하여 “회사”에서 규정한 게시기간을 초과한 경우</li>
                                        <li>바. “회사”에서 제공하는 “서비스”와 관련 없는 내용인 경우</li>
                                        <li>사. 불필요하거나 승인되지 않은 광고, 판촉물인 경우</li>
                                        <li>아. 기타 관계 법령 및 “회사”의 지침 등에 위반된다고 판단되는 경우</li>
                                    </ol>
                                    <li>(2) “회사”는 게시물에 관련된 세부이용지침을 별도로 정하여 시행할 수 있으며, 회원은 그 지침에 따라 각종 게시물(회원간 전달 포함)을 등록하거나 삭제하여야 합니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 16 조 (게시물의 저작권)</h3>
                                <ol>
                                    <li>(1) 회원이 “서비스” 내에 게시한 게시물(회원 간 전달 포함)의 저작권은 회원이 소유하며 “회사”는 “서비스” 내에 이를 게시할 수 있는 권리를 갖습니다.</li>
                                    <li>(2) “회사”는 게시한 회원의 동의 없이 게시물을 다른 목적으로 사용할 수 없습니다.</li>
                                    <li>(3) “회사”는 “서비스” 고도화를 위하여 회원의 저작물을 동의 하에 가공/게시할 수 있습니다.</li>
                                    <li>(4) “회사”는 회원이 “서비스”내에 게시한 게시물이 타인의 저작권 등 권리를 침해하더라도 이에 대한 민, 형사상의 책임을 부담하지 않습니다. 만일 회원이 타인의 저작권 등 권리를 침해하였음을 이유로 “회사”가 타인으로부터 손해배상청구 등 이의제기를 받은 경우 회원은 “회사”의 면책을 위하여 노력하여야 하며, “회사”가 면책되지 못한 경우 회원은 그로 인해 “회사”에 발생한 모든 손해를 부담하여야 합니다.</li>
                                    <li>(5) “회사”는 회원이 “서비스”를 해지하거나 적법한 사유로 “서비스”가 해지된 경우 해당 회원이 게시하였던 게시물을 삭제할 수 있습니다.</li>
                                    <li>(6) “회사”가 작성한 저작물에 대한 저작권은 “회사”에 귀속됩니다.</li>
                                    <li>(7) 회원은 “서비스”를 이용하여 얻은 정보를 가공, 판매하는 행위 등 “서비스”에 게재된 자료를 영리 목적으로 이용하거나 제3자에게 이용하게 할 수 없으며, 게시물에 대한 저작권 침해는 관계 법령의 적용을 받습니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 17 조 (회사의 의무)</h3>
                                <ol>
                                    <li>(1) 회사는 이 약관에서 정한 바에 따라 계속적, 안정적으로 "서비스"를 제공할 의무가 있으며 "메시지 시스템"이 최상의 상태를 유지하도록 관리하며 전송 데이터의 보안을 위해 최선을 다합니다.</li>
                                    <li>(2) 회사는 회원의 개인정보를 본인의 승낙 없이 타인에게 누설, 배포하여서는 아니 됩니다. 다만, 제1장 5조 (5)항의 경우에는 예외로 합니다.</li>
                                    <li>(3) 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 통보하여야 합니다.</li>
                                    <li>(4) 회사는 "서비스" 제공을 위한 시스템에 장애가 발생하거나 또는 고장 발생 시 그 사실을 전화, 메일 등 신속한 방법으로 회원에게 전달하고 복구를 위하여 최선의 조치를 강구합니다.<br></br>서비스 개선을 위한 개정 및 장비의 교체 등으로 일시 중지될 경우는 서비스 홈페이지에 중지됨을 회사는 사전에 회원에게 통지하여야 합니다.<br></br>단, 천재지변이나 불의의 사고 시에는 제외되나 사후에 이유를 회원에 통지하여야 합니다.</li>
                                    <li>(5) 회사는 회원의 회원정보를 보호하기 위해 보안시스템을 구축 운영하며, '개인정보처리방침'을 공지하고 준수합니다. 또한 회사는 '개인정보처리방침'에 따라 회원정보를 처리함에 있어 안정성 확보에 필요한 기술적 및 관리적 대책을 수립ㆍ운영합니다.</li>
                                    <li>(6) 회사가 제공하는 서비스로 인하여 회원에게 손해가 발생한 경우 그러한 손해가 회사의 고의나 중과실에 의해 발생한 경우에 한하여 회사에서 책임을 부담하며, 그 책임의 범위는 통상손해에 한합니다.</li>
                                    <li>(7) 회사는 회원이 서비스 제공 목적에 맞는 이용 여부를 확인하기 위하여 상시적으로 모니터링을 실시하며, "스팸", "불법스팸" 및 "문자피싱"을 전송한 사실을 확인한 경우 한국인터넷진흥원 불법스팸대응센터에 관련 자료를 첨부하여 신고할 수 있습니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제 18 조 (회원의 의무)</h3>
                                <p>회원은 하기 사항을 숙지하고, 이를 위반하는 경우에 회사는 회원의 서비스 이용제한 및 적법조치를 포함한 제재를 가할 수 있습니다.</p>
                                <ol>
                                    <li>(1) 회원은 “회사”의 직원이나 “서비스” 운영자를 가장하거나 사칭하여 SMS 발송 또는 연락을 취하는 행위를 할 수 없습니다.</li>
                                    <li>(2) 회원은 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 포함)의 전송 또는 게시 행위를 할 수 없습니다. </li>
                                    <li>(3) 회원은 “회사”의 “서비스”를 이용하여 얻은 정보를 “회사”의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위를 할 수 없습니다.</li>
                                    <li>(4) 회원은 재판매의 목적으로 “서비스”를 이용할 수 없습니다.</li>
                                    <li>(5) 회원은 타인의 결제정보 등을 도용하거나 부정한 행위로 거래를 할 수 없습니다.</li>
                                    <li>(6) “서비스”를 통해 발송되는 모든 메시지는 발송 채널의 주체인 ‘SKT’의 검수를 받은 후 승인된메시지에 한하여 발송하여야 합니다.</li>
                                    <li>(7) 아이디와 비밀번호에 관한 모든 관리 책임은 회원에게 있습니다.</li>
                                    <li>(8) 회원에게 부여된 아이디와 비밀번호의 관리소홀, 부정사용에 의하여 발생한 결과에 대한 책임은 회원에게 있습니다.</li>
                                    <li>(9) 회원은 아이디 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하여야 합니다.</li>
                                    <li>(10) 회원은 서비스의 이용권한, 기타 서비스 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다.</li>
                                    <li>(11) 회원은 회사로부터 특별한 권한을 받지 않고 회사의 클라이언트 프로그램을 변경하거나 회사의 서버를 해킹할 수 없습니다.</li>
                                    <li>(12) 회원은 기타 불법적이거나 부당한 행위를 할 수 없습니다.</li>
                                    <li>(13) 회원은 서비스의 본래 목적 외의 용도로 서비스를 이용하여서는 아니 되며 타인의 지적재산권 또는 타인이 사생활을 침해하는 내용을 전송할 목적으로 사용해선 안 되고 제3자에게 임의로 해당 서비스를 임대하여서도 안 됩니다.</li>
                                    <li>(14) 회원은 "정보통신망법"에 따른 광고성 정보 전송 시 의무사항 및 회사의 "약관"을 준수하여야 하며, 기타 회사의 업무 수행에 현저한 지장을 초래하는 행위를 하여서는 안 됩니다.</li>
                                    <li>(15) 회원은 공공의 안녕, 질서 또는 미풍양속을 해하는 다음 각 호의 내용으로 메시지를 전송하여서는 안 됩니다.</li>
                                    <ol>
                                        <li>① 범죄 행위를 목적으로 하거나 범죄 행위를 교사하는 내용</li>
                                        <li>② 반국가적 행위의 수행을 목적으로 하는 내용</li>
                                        <li>③ 선량한 풍속, 기타 사회질서를 해하는 내용</li>
                                    </ol>
                                    <li>(16) 회원은 "정보통신망법"에 따라 메시지 전송을 위해 이동통신사 가입자의 사전 수신동의를 직접 얻어야 하고, "스팸", "불법스팸" 및 "문자피싱" 전송을 위해 서비스를 이용하여서는 아니 되며, 회사를 통해 전달되는 수신거부 요청에 대해서는 즉각적으로 처리하고 24시간 이내에 처리결과를 회사에 회신하여야 하며 본 항의 위반으로 발생하는 모든 민 형사상의 책임은 회원이 직접 부담해야 합니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제19조 (회원의 ID 및 비밀번호에 대한 의무)</h3>
                                <ol>
                                    <li>(1) 회원은 ID 및 비밀번호를 철저히 관리하여야 하며, 관리소홀, 부정사용 등에 의하여 발생하는 모든 결과에 대한 책임은 회원 본인이 부담하며, “회사”는 이에 대한 책임을 부담하지 않습니다.</li>
                                    <li>(2) 회원은 본인의 ID 및 비밀번호를 제3자에게 이용하게 하여서는 아니 되며, 회원 본인의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지하는 경우에는 즉시 비밀번호를 변경하여야 하며, 해당 사실을 “회사”에 통지하고 “회사”가 안내하는 바에 따라야 합니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제20조 (회원에 대한 통지)</h3>
                                <ol>
                                    <li>(1) 회원에 대한 통지를 하는 경우 “회사”는 회원이 등록한 E-mail 주소 또는 SMS, 기타 전자적 전송매체를 통해 할 수 있습니다.</li>
                                    <li>(2) “회사”는 불특정 다수 회원에 대한 통지의 경우 “서비스” 공지사항 등에 게시함으로써 개별 통지에 갈음할 수 있습니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제21조 (회원의 개인정보보호)</h3>
                                <p>
                                    “회사”는 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보보호에 관한 사항은 관련법령 및 “회사”가 정하는 통합개인정보처리방침에 정한 바에 따릅니다.
                                </p>
                            </div>
                            <div className="sec">
                                <h3>제22조 (개인정보의 처리 업무 위탁)</h3>
                                <p>
                                    “회사”는 수집된 개인정보의 처리 업무를 스스로 수행할 것을 원칙으로 하나, 필요한 경우 일부 도는 전부를 “회사”가 선정한 제3자에게 위탁할 수 있습니다.
                                </p>
                            </div>
                            <h5>제3장 포인트 관련 규정</h5>
                            <div className="sec">
                                <h3>제23조 (포인트의 사용)</h3>
                                <ol>
                                    <li>(1) 충전한 비즈팅 포인트에 대한 차감은 회사가 제공하는 서비스를 이용하는 시점에서 즉시 이루어집니다.</li>
                                    <li>(2) 정상적이지 않은 방법으로 비즈팅 포인트를 충전하거나 사용한 경우 해당 비즈팅 포인트만큼을 이용자의 비즈팅 포인트에서 강제로 차감할 수 있으며, 서비스 이용을 제한할 수 있습니다. </li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제24조 (포인트의 차감)</h3>
                                <ol>
                                    <li>(1) 충전한 비즈팅 포인트에 대한 차감은 회사가 제공하는 서비스를 이용하는 시점에서 즉시 이루어집니다.</li>
                                    <li>(2) 정상적이지 않은 방법으로 비즈팅 포인트를 충전하거나 사용한 경우 해당 비즈팅 포인트만큼을 이용자의 비즈팅 포인트에서 강제로 차감할 수 있으며, 서비스 이용을 제한할 수 있습니다. </li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제25조 (포인트의 사용제한)</h3>
                                <ol>
                                    <li>(1) 회원은 다음 각호에 해당하는 행위를 하여서는 아니 되며 이를 위반할 경우 회사는 회원에 대하여 비즈팅 포인트 이용을 정지시킬 수 있습니다.
                                        <ol>
                                            <li>가. 타인의 이용 아이디 및 비밀번호를 부정하게 사용하는 경우</li>
                                            <li>나. 타인의 명의나 개인정보를 도용하여 서비스를 이용하는 경우</li>
                                            <li>다. 타인의 결제정보 등을 도용하거나 부정한 행위로 거래를 하는 경우</li>
                                            <li>라. 비즈팅 포인트 서비스 제공에 지장을 초래하는 경우</li>
                                            <li>마. 본 약관에 위반하는 방법으로 비즈팅 포인트 서비스를 이용하는 경우</li>
                                            <li>바. 기타 법령에 위배되는 행위를 하는 경우</li>
                                        </ol>
                                    </li>
                                    <li>(2) 회사는 비즈팅 포인트 이용을 제한할 경우 이용 제한 내용과 소명 절차를 이용자가 지정한 전자우편, SMS 등으로 통지하여 이용자가 이를 소명할 수 있는 기회를 부여합니다</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제26조 (포인트의 충전방법)</h3>
                                <ol>
                                    <li>(1) 비즈팅 포인트 충전은 회사가 정한 다양한 결제수단을 이용하여 충전할 수 있습니다
                                    </li>
                                    <li>(2) 비즈팅 포인트의 충전을 위해 다음과 같은 결제수단이 제공되며, 회사의 사정으로 추가 및 서비스 중지가 될 수 있습니다.
                                        <ol>
                                            <li>가. 신용카드</li>
                                            <li>나. 계좌이체</li>
                                            <li>다. 무통장입금</li>
                                        </ol>
                                    </li>
                                    <li>(3) 회사가 제공하는 결제수단은 회사의 운영방침에 따라 이용이 제한될 수 있습니다.</li>
                                    <li>(4) 회사가 제공하는 시스템상의 장애에 의하여 충전이 정상적으로 이루어지지 못한 경우에 비즈팅 포인트로 재충전을 받을 수 있습니다. </li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제27조 (포인트의 유효기간)</h3>
                                <ol>
                                    <li>(1) 비즈팅 포인트의 유효기간은 충전일 또는 구매일로부터 60개월입니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제28조 (포인트의 환불)</h3>
                                <ol>
                                    <li>(1) 유효기간이 지난 비즈팅 포인트는 환불받으실 수 없습니다.</li>
                                    <li>(2) 충전에 해당되는 결제 수단의 승인 취소 또는 결제 수단으로 결제 금액을 재 환원하는 것으로 환불을 대신할 수 있을 경우 회사는 현금 환불을 하지 않습니다.</li>
                                    <li>(3) 아래의 내용에 해당하는 경우 환불 신청을 통해 회사가 정한 절차에 따라 환불을 받을 수 있습니다.
                                        <ol>
                                            <li>① 비즈팅 포인트를 충전했으나 사용할 수 있는 서비스가 전무하며 그에 대한 책임이 전적으로 회사에 있는 경우 (단, 시스템 정기점검 등의 불가피한 경우는 제외)</li>
                                            <li>② 비즈팅 포인트 잔액이 남아 있는 상태에서 회원이 변경된 약관에 동의하지 않는다는 이유로 탈퇴하고, 회사가 이를 정당하다고 판단하는 경우</li>
                                            <li>③ 기타 고객의 권리보호를 위하여 회사가 별도로 정한 경우</li>
                                        </ol>
                                    </li>
                                    <li>(4) 아래 내용에 해당하는 경우 캐시는 자동으로 소멸됩니다.
                                        <ol>
                                            <li>① 회원의 귀책사유로 탈퇴된 경우</li>
                                            <li>② 회원의 귀책사유로 탈퇴한 경우</li>
                                            <li>③ 제18조 (회원의 의무)를 위반하여 탈퇴한 경우</li>
                                        </ol>
                                    </li>
                                    <li>(5) 환불 신청시 결제금액에 따라 사용건수에 따른 전송요금, 재정경제부에서 고시한에서 규정한 위약금(총 이용료의 10%) 및 PG수수료, 송금비용을 제외한 잔액을 환불하여 드립니다. 단, 위약금 및 PG수수료, 송금비용, 결제금액에 따라 추가 증여된 캐시의 합계는 최소 5,000원입니다. 따라서 5,000원 미만의 캐시는 회원 탈퇴시 자동 소멸됩니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제29조 (포인트의 환불 절차)</h3>
                                <ol>
                                    <li>(1) 비즈팅 포인트의 환불 절차는 다음과 같습니다.
                                        <ol>
                                            <li>가. 환불 신청 시 이용자는 비즈팅에 환불 신청 접수를 하여야 합니다.</li>
                                            <li>나. 환불 신청은 비즈팅 고객센터 메일(tf@biztalk.co.kr)을 통하여 신청하실 수 있습니다.</li>
                                            <li>다. 회사는 환불 신청 접수 후 환불요청 확인절차를 거쳐 14일 이내에 제3장 28조 (포인트의 환불)에 따라 충전금액 환불을 진행합니다.</li>
                                        </ol>
                                    </li>
                                    <li>(2) 다음 사항에 해당될 경우에는 환불이 불가능합니다.
                                        <ol>
                                            <li>가. 이벤트 행사 등 무상으로 받은 비즈팅 포인트인 경우</li>
                                            <li>나. 비 정상적인 방법으로 포인트를 충전한 경우</li>
                                        </ol>
                                    </li>
                                </ol>
                            </div>
                            <h5>제4장 계약 해지 및 이용 제한</h5>
                            <div className="sec">
                                <h3>제30조 (계약해지)</h3>
                                <p>회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 회사의 서비스 페이지를 통해 회사에 해지 신청을 하여야 합니다.</p>
                            </div>
                            <div className="sec">
                                <h3>제31조 (이용 제한)</h3>
                                <ol>
                                    <li>(1) 회사는 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.</li>
                                    <li>(2) 서비스의 원활한 운영을 위하여 회원이 전송하는 메시지에 대해 일별 또는 월별 전송 허용 건수 및 전송 시간 등을 제한할 수 있으며 개별 메시지에 대한 재전송 횟수를 한정할 수 있습니다.</li>
                                    <li>(3) 회사는 회원의 서비스 이용 내용이 다음 각 호에 해당하는 경우 서비스 이용을 제한할 수 있습니다.
                                        <ol>
                                            <li>① 제18조 규정에 의한 회원의 의무를 이행하지 않은 경우</li>
                                            <li>② 서비스의 안정적 운영을 방해할 목적으로 다량의 정보를 전송하거나 수신자의 의사에 반하여 광고성 정보를 지속적으로 전송하는 경우</li>
                                            <li>③ 다른 회원 또는 제3자의 지적재산권을 침해하는 경우</li>
                                            <li>④ 방송통신심의위원회의 시정요구가 있거나 불법선거운동과 관련하여 중앙선거관리위원회의 유권해석을 받은 경우</li>
                                            <li>⑤ 타 회원의 아이디를 부정하게 이용하거나 타인의 명예를 손상시키거나 불이익을 주는 경우</li>
                                            <li>⑥ 서비스정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우</li>
                                            <li>⑦ 서비스에 위해를 가하거나 서비스의 건전한 이용을 저해하는 경우</li>
                                            <li>⑧ 타인의 명의를 이용하여 신청(계약)한 경우 또는 신청서 또는 계약서의 내용을 허위로 기재하였거나 허위서류를 첨부하여 서비스의 이용승낙을 득한 경우</li>
                                            <li>⑨ 국익 또는 사회적 공익을 저해할 목적으로 이용되는 경우</li>
                                            <li>⑩ 메시지 수신자가 "스팸"으로 신고하거나 회원이 발송하는 메시지가 "불법스팸"임이 판명될 경우</li>
                                            <li>⑪ 회사의 수신거부 요청 처리에 불성실하여 수신거부 요청 건수가 감소되지 않거나 발송금지를 요청한 메시지 내용이 중복적으로 발송될 경우</li>
                                            <li>⑫ 방송통신위원회 또는 한국인터넷진흥원이 "스팸", "불법스팸", "문자피싱" 전송 사실을 확인하여 이용정지를 요청하는 경우 </li>
                                        </ol>
                                    </li>
                                    <li>(4) 회사는 상기 3항 10호 내지 12호의 경우 회원에게 전송량 축소, 아이디 중지 등의 방법으로 서비스 이용을 제한할 수 있습니다.</li>
                                </ol>
                            </div>

                            <h5>제5장 손해배상 및 면책조항 및 기타조항</h5>
                            <div className="sec">
                                <h3>제32조 (손해배상)</h3>
                                <ol>
                                    <li>(1) 회사는 서비스 이용과 관련하여 회사의 귀책사유로 인하여 발생되지 않은 회원의 손실에 관해서는 책임을 지지 않습니다.</li>
                                    <li>(2) 회원이 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.</li>
                                    <li>(3) 회원이 서비스를 이용하는 과정에서 행한 불법행위나 본 약관 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우, 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다.</li>
                                    <li>(4) "정보통신망법"에서 규정한 사항을 위반하여 발생한 손해에 대한 책임은 회사에서 책임지지 않습니다. 또한 회사가 물질적, 정신적 손해를 입을 경우 이용고객은 회사가 입은 손해에 대한 배상 책임 의무가 있습니다.</li>
                                </ol>
                            </div>

                            <div className="sec">
                                <h3>제33조 (면책조항)</h3>
                                <ol>
                                    <li>(1) “회사”는 제12조에 의거 회원의 “서비스” 이용을 제한하는 경우 이로 인해 발생할 수 있는 회원의 손해 등에 대해서는 책임이 면제됩니다.</li>
                                    <li>(2) 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</li>
                                    <li>(3) 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여는 책임을 지지 않습니다.</li>
                                    <li>(4) 회사는 회원이 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</li>
                                    <li>(5) 회사는 회원 상호간 또는 회원과 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다. </li>
                                    <li>(6) 회사는 제31조에 의거 이용고객의 서비스 이용을 제한하는 경우 이로 인해 발생할 수 있는 이용고객의 손해 등에 대해서는 책임이 면제됩니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>제33조 (면책조항)</h3>
                                <ol>
                                    <li>(1) 회사와 이용고객간의 통신은 서면, 전자우편, 팩스 등으로 합니다.</li>
                                    <li>(2) 분쟁으로 소송이 제기될 경우, 대한민국 서울지방법원을 관할법원으로 합니다.</li>
                                </ol>
                            </div>
                            <div className="sec">
                                <h3>부칙</h3>
                                <ol>
                                    <li>(1) 본 "약관"은 2024년 8월 일부터 시행됩니다.</li>
                                </ol>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

          </>
    );
};

export default UseAgreement;
